import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customerCheckIn } from '@/api/customerCheckIn';
import { queryKeys } from '@/constants/queryKeys';
import { useBrowserUserId } from './useBrowserUserId';
import useValidateQueryParams from './useValidateQueryParams';

export const useCustomerCheckIn = () => {
  const queryClient = useQueryClient();
  const { queryParams } = useValidateQueryParams();
  const { outletId, tableNumber } = queryParams();
  const browserUserId = useBrowserUserId();
  const payload = {
    outletId: outletId || '',
    tableNumber: tableNumber || '',
    customerId: browserUserId || '',
  };

  return useMutation({
    mutationFn: () => customerCheckIn(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.customerCheckIn(payload),
        exact: false,
      });
    },
  });
};
